import { PREFIX_ACTIONS } from './constants';
import { IApiGetChannelsParam, IApiGetDemoDataParam } from '../interfaces/api';
import { createAsyncAction } from 'services/actionConfigs';

const getDemoData = createAsyncAction<IApiGetDemoDataParam>(PREFIX_ACTIONS + 'getDemoData');
const getListChannels = createAsyncAction<IApiGetChannelsParam>(PREFIX_ACTIONS + 'getListChannels');
const getListLayouts = createAsyncAction<void>(PREFIX_ACTIONS + 'getListLayouts');
const deleteChannel = createAsyncAction<string>(PREFIX_ACTIONS + 'deleteChannel');
/**
 * TODO:
 * please replace channel to your feature name
 * ex:
 * channelActions => bookingActions
 */
const channelActions = {
  getDemoData,
  getListChannels,
  getListLayouts,
  deleteChannel,
};

export default channelActions;

